import * as gfunctions from '../../../js/generalFunctions';

CCL.ajaxCLP = {
  autoload: [
    ['initialCLPDataLoad', $('.c-plp-products-ajax').length > 0]
  ],

  currentPage: 0,
  selectedRating: 0,
  initialResponse: {},
  promise: {},
  promoResponse: {},

  // Load initial json data
  initialCLPDataLoad(query, firstTimeLoad = true) {
    gfunctions.showLoader();
    let ajaxUrl = '';
    let ajaxType = '';
    const categoryId = $('.c-plp-products-ajax').data('categoryid');
    const rootCategoryCode = $('.c-plp-products-ajax').data('parentcategoryid');
    const token = $('#csrfSessionToken').data('csrf');
    let finalQuery = '';
    if (rootCategoryCode) {
      finalQuery = query ? `?q=${query}&rootCategoryCode=${rootCategoryCode}` : `?rootCategoryCode=${rootCategoryCode}`;
    } else {
      finalQuery = query ? `?q=${query}` : '';
    }

    // take query from browser URL bar
    if (finalQuery) {
      window.history.replaceState(null, null, finalQuery);
    } else {
      finalQuery = window.location.search ? window.location.search : finalQuery;
    }

    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = finalQuery ? `/_ui/responsive/ccl/assets/templates/ajax-clp/shoreex.json?q=${finalQuery}` : '/_ui/responsive/ccl/assets/templates/ajax-clp/shoreex.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = finalQuery ? `/shop/plp/search/${categoryId}${finalQuery}` : `/shop/plp/search/${categoryId}`;
      ajaxType = 'GET';
    }

    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      if (response.showPresaleCutoffAlert) {
        $('.c-alert-banner-cut-off-notification').css('display', 'block');
      }
      this.currentPage = 0;
      if (response && response.productCategorySearchPageData && response.productCategorySearchPageData.pagination) {
        // Update current page on every call
        this.currentPage = response.productCategorySearchPageData.pagination.currentPage;
      }

      this.initialResponse = response;

      if (response.userFlowType === 'LOGGED_IN_BUY' && ($('#promotionURL').data('promotionurl') && $('#promotionURL').data('promotionurl') !== '')) {
        // If we have strike-through promotional pricing
        this.promise = this.promotionPricingAjax(response);
      }

      // Deal of the day Data
      const { dealOfTheDayProduct } = response;
      if (dealOfTheDayProduct) {
        // Get Deal of the day pills
        dealOfTheDayProduct.pillsData = {};
        dealOfTheDayProduct.pillsData.isFeatured = this.isFeaturedPill(dealOfTheDayProduct);
        dealOfTheDayProduct.pillsData.isNew = this.isNewPill(dealOfTheDayProduct);
        dealOfTheDayProduct.pillsData.showLimitedAvailability = dealOfTheDayProduct.showLimitedAvailability;
        dealOfTheDayProduct.pillsData.isdDiscounteligible = this.isDiscounteligiblePill(dealOfTheDayProduct);
        dealOfTheDayProduct.pillsData.isSoldOut = this.isSoldOutPill(dealOfTheDayProduct, response);

        // Get HTML for price - deal Of The Day
        const dealOfTheDayProductPrice = this.priceHtml(dealOfTheDayProduct, response);
        dealOfTheDayProduct.priceDiv = dealOfTheDayProductPrice.priceDiv;
        dealOfTheDayProduct.priceADA = dealOfTheDayProductPrice.priceADA;

        // Get classes and attributes based on product data
        const dealOfTheDayProductBtn = this.addToCartBtnClasses(dealOfTheDayProduct, response);
        dealOfTheDayProduct.addToCartBtnClass = dealOfTheDayProductBtn.addToCartBtnClass;
        dealOfTheDayProduct.addToCartBtnAttributes = dealOfTheDayProductBtn.addToCartBtnAttributes;

        // Get EyeBrow HTML
        dealOfTheDayProduct.eyeBrowHtml = this.eyeBrowHtml(dealOfTheDayProduct);

        // Get Carousel HTML
        dealOfTheDayProduct.carouselHtml = `${this.getCarouselHtml(dealOfTheDayProduct, response)}?w="848"&h="430"`;

        // Get Rating stars HTML
        if ((dealOfTheDayProduct.ratingsEnabled || response.ratingsEnabled) && dealOfTheDayProduct.productAverageRating !== null) {
          dealOfTheDayProduct.ratingStars = this.tilesRating(dealOfTheDayProduct.productAverageRating, dealOfTheDayProduct.code);
        }

        // Description
        if (dealOfTheDayProduct.description !== null) {
          dealOfTheDayProduct.smallDescription = `${dealOfTheDayProduct.description.substring(0, 120)}...`;
        }
      }

      response.paginationFooterHtml = this.getPaginationFooterHtml(response);

      if (response.productCategorySearchPageData) {
        $.each(response.productCategorySearchPageData.results, (key, val) => {
          // Get HTML for price
          val.pillsData = {};
          val.pillsData.isFeatured = this.isFeaturedPill(val);
          val.pillsData.isNew = this.isNewPill(val);
          val.pillsData.showLimitedAvailability = val.showLimitedAvailability;
          val.pillsData.isdDiscounteligible = this.isDiscounteligiblePill(val);
          val.pillsData.isSoldOut = this.isSoldOutPill(val, response);

          // Get HTML for price
          const price = this.priceHtml(val, response);
          val.priceDiv = price.priceDiv;
          val.priceADA = price.priceADA;

          // Get classes and attributes based on product data
          const btn = this.addToCartBtnClasses(val, response);
          val.addToCartBtnClass = btn.addToCartBtnClass;
          val.addToCartBtnAttributes = btn.addToCartBtnAttributes;

          // Get Carousel HTML
          val.carouselHtml = this.getCarouselHtml(val, response);

          // is wheelchair
          val.isWheelChair = this.isWheelChair(val);

          // Get EyeBrow Text HTML
          val.eyeBrowHtml = this.eyeBrowHtml(val);

          if ((val.ratingsEnabled || response.ratingsEnabled) && val.productAverageRating !== null) {
            val.productAverageRating = val.productAverageRating.toFixed(1);
            val.ratingStars = this.tilesRating(val.productAverageRating, val.code);
          }

          if ($('#lazyLoadingEnabled').data('enabled') === 'true' || $('#lazyLoadingEnabled').data('enabled') === true) {
            val.lazyLoadingEnabled = true;
          } else {
            val.lazyLoadingEnabled = false;
          }
        });
      }
      // Group ports by region
      response.portByRegionArr = this.groupPortByRegion(response);

      // load all the product tiles html
      this.loadCLPTiles(response);

      // load all the product facets html
      if (response.productCategorySearchPageData && response.productCategorySearchPageData.pagination.totalNumberOfResults > 0) {
        this.loadCLPFacets(response, firstTimeLoad);
      }

      // load sorting options for first time
      if (firstTimeLoad) {
        this.loadSortingDropdown(response);
      }

      // load click event for pagination
      this.showPagination(response, firstTimeLoad);
      gfunctions.hideLoader();
    }).fail(() => {
      console.log('error while fetching clp data');
      gfunctions.hideLoader();
    });
  },

  loadCLPTiles(jsonData) {
    const pageName = ACC.pageName; // eslint-disable-line
    if (!pageName.toLowerCase().includes('spa') || !pageName.toLowerCase().includes('dining')) {
      gfunctions.showLoader();
    }
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/ajax-clp/ajax-clp.html'
    }).done((response) => {
      const html = gfunctions.createDynamicHTML(response, jsonData);
      $('.c-plp-products-ajax').empty().append(html);
      if (jsonData.productCategorySearchPageData && jsonData.productCategorySearchPageData.breadcrumbs && !jsonData.productCategorySearchPageData.breadcrumbs.length) {
        $('.c-sorting-category').css('border-bottom', 'none');
        $('.tag-wrap').css('padding', '5px 0');
      } else {
        $('.c-sorting-category').css('border-bottom', '1px solid #ececec');
        $('.tag-wrap').css('padding', '16px 0');
      }
      // if (jsonData.atcDisabledDomains && jsonData.atcDisabledDomains.length && jsonData.sessionLanguageCurrency !== null) {
      // if (jsonData.atcDisabledDomains.includes(jsonData.sessionLanguageCurrency)) {
      // $('.general-add-to-cart-btn').hide();
      // }
      // }
      this.tilesClickEvents();

      if (jsonData.userFlowType === 'LOGGED_IN_BUY' && ($('#promotionURL').data('promotionurl') && $('#promotionURL').data('promotionurl') !== '')) {
        // using promise from promo ajax call
        this.promise.then((res) => {
          this.promoResponse = res;
          if (this.promoResponse && this.promoResponse.promotionsData.length) {
            $.each(this.promoResponse.promotionsData, (key, val) => {
              // show promoPill for all the CLP products
              $('body').find(`.${val.productBaseCode} .pills-wrap`).append(
                `<div class="best-seller general-best-seller">
                  <span class="info-icon" aria-hidden="true">
                      <img src="/_ui/responsive/ccl/assets/icons/star_white.svg" alt="Featured" width="11" height="12">
                  </span>
                  ${val.promotionResultsData[0].description}
                </div>`
              );

              if (val.productType === 'EX' || val.productType === 'DI') {
                this.shoreExPromoPriceHtml(val);
              }

              if (val.productType === 'FS') {
                this.funshopPromoPriceHTML(val);
              }
            });
          }
        }).catch(() => {
          console.log('error while fetching clp data');
          gfunctions.hideLoader();
        });
      }

      // Switch for favorite functionality
      if ($('#isfavoritesEnabled').length) {
        if ($('#isfavoritesEnabled')[0].dataset.enabled === true || $('#isfavoritesEnabled')[0].dataset.enabled === 'true') {
          $('body').find('.fav-section').removeClass('d-none');
        }
      }
      if (!pageName.toLowerCase().includes('spa') || !pageName.toLowerCase().includes('dining')) {
        gfunctions.hideLoader();
      }
    }).fail(() => {
      console.log('error while loading html');
      gfunctions.hideLoader();
    });
  },

  loadCLPFacets(jsonData, firstTimeLoad) {
    const pageName = ACC.pageName; // eslint-disable-line
    if (!pageName.toLowerCase().includes('spa') || !pageName.toLowerCase().includes('dining')) {
      gfunctions.showLoader();
    }
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/ajax-clp/facets-ajax-clp.html'
    }).done((response) => {
      const html = gfunctions.createDynamicHTML(response, jsonData);
      $('.c-category-facets #category-facets-accordion').empty().append(html);

      if (firstTimeLoad) {
        this.facetsClickEvents();
      }
      if (jsonData.productCategorySearchPageData.facets.length && jsonData.productCategorySearchPageData.facets.filter(x => x.code === 'averageReview').length > 0) {
        $('.facets-rating').starRating({
          starSize: 25,
          disableAfterRate: false,
          callback: (currentRating, $el) => {
            this.selectedRating = currentRating;
            const query = this.getQuery(this.initialResponse.productCategorySearchPageData.currentQuery.query.value);
            this.initialCLPDataLoad(query, false);
          },
          onHover(currentIndex, currentRating, $el) {
            const text = currentIndex < 5 ? `${currentIndex} AND UP` : currentIndex;
            $($el).parents('.review').find('.review-text').text(text);
          },
          onLeave(currentIndex, currentRating, $el) {
            const text = currentRating < 5 ? `${currentRating} AND UP` : currentRating;
            $($el).parents('.review').find('.review-text').text(text);
          }
        });
        $('.facets-rating').starRating('setRating', jsonData.selectedRating ? jsonData.selectedRating : 0);
      }
      if (!firstTimeLoad) {
        setTimeout(() => {
          $('#facetSearchResult').empty().append(`<span role='alert'>${jsonData.productCategorySearchPageData.pagination.totalNumberOfResults} items found</span>`);
        }, 300);
      }
      if (!pageName.toLowerCase().includes('spa') || !pageName.toLowerCase().includes('dining')) {
        gfunctions.hideLoader();
      }
    }).fail(() => {
      console.log('error while loading html');
      gfunctions.hideLoader();
    });
  },

  loadSortingDropdown(jsonData) {
    $('body').on('click keypress', '.c-sorting-category button.dropdown-item', (e) => {
      $('.c-sorting-category button.dropdown-item').removeClass('active');
      $(e.currentTarget).addClass('active');
      $('.c-sorting-category .dropdown-toggle')[0].innerText = $('.c-sorting-category button.dropdown-item.active')[0].innerText;
      const query = this.getQuery(this.initialResponse.productCategorySearchPageData.currentQuery.query.value);
      this.initialCLPDataLoad(query, false);
      const selectedSort = e.currentTarget.innerText;
      setTimeout(() => {
        $(() => {
          $('.c-sorting-category .dropdown-toggle').addClass('ada-highlighted');
          $('.c-sorting-category .dropdown-toggle').attr('aria-label', `Sort option ${selectedSort} selected`);
          $('.c-sorting-category .dropdown-toggle').focus();
        });
      }, 3000);
    });
  },

  showPagination(jsonData, firstTimeLoad) {
    if (jsonData && jsonData.productCategorySearchPageData && jsonData.productCategorySearchPageData.pagination) {
      const pages = jsonData.productCategorySearchPageData.pagination.numberOfPages;
      let { numberPagesShown } = jsonData;
      numberPagesShown = pages < numberPagesShown ? pages : numberPagesShown;
      const tmp = Number.isInteger(this.currentPage / numberPagesShown) ? (this.currentPage / numberPagesShown) + 0.1 : (this.currentPage / numberPagesShown);
      const range = Math.ceil(tmp);
      const start = ((range * numberPagesShown) - numberPagesShown) + 1;
      const end = range * numberPagesShown < pages ? range * numberPagesShown : pages;

      let html = '';
      if (pages > 1) {
        html = `<li class="page-item previous" value="${this.currentPage - 1}">
      <a class="page-link previous" href="javascript:;" aria-label="go to previous page"><span class="general-pagination-previous">Previous</span>
      </a></li>`;

        if (this.currentPage < numberPagesShown) {
          for (let i = 1; i <= numberPagesShown; i++) {
            if (i - 1 === this.currentPage) {
              html += `<li class="page-item active" value="${i - 1}"><a class="page-link" href="javascript:;">${i}<span class="sr-only general-pagination-current">(current page ${i} out of ${pages})</span> </a></li>`;
            } else {
              html += `<li class="page-item" value="${i - 1}"><a class="page-link" href="javascript:;" aria-label="${i} out of ${pages} pages">${i}</a></li>`;
            }
          }
        } else {
          for (let i = start; i <= end; i++) {
            if (i - 1 === this.currentPage) {
              html += `<li class="page-item active" value="${i - 1}"><a class="page-link" href="javascript:;">${i}<span class="sr-only general-pagination-current">(current page ${i} out of ${pages})</span></a></li>`;
            } else {
              html += `<li class="page-item" value="${i - 1}"><a class="page-link" href="javascript:;" aria-label="${i} out of ${pages} pages">${i}</a></li>`;
            }
          }
        }

        html += `<li class="page-item next" value="${this.currentPage + 1}">
      <a href="javascript:;" class="page-link next" aria-label="go to next page"><span class="general-pagination-next">Next</span>
         </a>
      </li>`;
      }
      $('.c-pagination .pagination').empty().append(html);
      if (this.currentPage === 0) {
        $('.pagination .next').removeClass('disabled');
        $('.pagination .previous').addClass('disabled');
        $('.pagination .previous').attr('tabindex', '-1');
        $('.pagination .next').removeAttr('tabindex');
      } else if (this.currentPage + 1 === pages) {
        $('.pagination .next').addClass('disabled');
        $('.pagination .previous').removeClass('disabled');
        $('.pagination .next').attr('tabindex', '-1');
        $('.pagination .previous').removeAttr('tabindex');
      }

      // register click event one time only
      if (firstTimeLoad) {
        $('body').on('click keypress', '.pagination .page-link', (e) => {
          const pageName = ACC.pageName; // eslint-disable-line
          if (!pageName.toLowerCase().includes('spa') || !pageName.toLowerCase().includes('dining')) {
            gfunctions.showLoader();
          }
          $('.pagination .page-item').removeClass('active');
          $(e.currentTarget).parents('.page-item').addClass('active');

          if (Number(e.currentTarget.innerText) === pages) {
            $('.pagination .next').addClass('disabled');
            $('.pagination .previous').removeClass('disabled');
          } else if (Number(e.currentTarget.innerText) === 1) {
            $('.pagination .next').removeClass('disabled');
            $('.pagination .previous').addClass('disabled');
          } else {
            $('.pagination .next').removeClass('disabled');
            $('.pagination .previous').removeClass('disabled');
          }
          const query = this.getQuery(this.initialResponse.productCategorySearchPageData.currentQuery.query.value);
          this.initialCLPDataLoad(query, false);

          $('html, body').animate({
            scrollTop: $('.c-sorting-category').offset().top + ($('.c-sorting-category')[0].clientHeight - 100)
          }, 500);

          setTimeout(() => {
            $(() => {
              $('body').addClass('ccl-ada-focus');
              $('.c-plp-products-ajax .ccl_product_title:first').addClass('ada-highlighted');
              $('.c-plp-products-ajax .ccl_product_title:first').focus();
            });
          }, 1500);
          if (!pageName.toLowerCase().includes('spa') || !pageName.toLowerCase().includes('dining')) {
            gfunctions.hideLoader();
          }
        });
      }
    }
  },

  // get query for ajax call-facet, sort, pagination
  getQuery(query = null, fromFacets = false) {
    // generate facet query
    const selectedSortData = this.initialResponse.productCategorySearchPageData.sorts.filter(x => x.selected)[0].code;
    let facetQuery = '';
    let finalQuery = '';
    if (query) {
      /* eslint-disable */
      facetQuery = query.split(selectedSortData)[1] ? query.split(selectedSortData)[1] : '';
      /* eslint-enable */
    } else {
      $('.facet-body-section .facet-checkbox').each((index, element) => {
        if (element.checked) {
          if (element.dataset.query) {
            const elementQuery = element.dataset.truncatequery.split(selectedSortData)[1] ? element.dataset.truncatequery.split(selectedSortData)[1] : element.dataset.truncatequery.split(selectedSortData)[0];
            facetQuery += elementQuery;
          }
        }
      });
    }

    // generate sort query
    const selectedSort = $('.c-sorting-category button.dropdown-item.active').length ? $('.c-sorting-category button.dropdown-item.active')[0].value : $('.c-sorting-category button.dropdown-item')[0].value;

    // generate pagination query
    let selectedPage = $('.page-link').length ? $('.pagination .active')[0].value : 0;
    if (fromFacets) {
      selectedPage = 0;
    }

    if (this.selectedRating > 0) {
      if (facetQuery.includes('averageReview')) {
        const strLength = 'averageReview'.length;
        const indexAVR = facetQuery.indexOf('averageReview');
        const totalIndex = strLength + indexAVR + 1;
        const previousSelectedRating = Number(this.initialResponse.selectedRating);

        if (Number.isInteger(previousSelectedRating)) {
          facetQuery = `${facetQuery.slice(0, totalIndex)}${this.selectedRating}${facetQuery.slice(totalIndex + 1)}`;
        } else {
          facetQuery = `${facetQuery.slice(0, totalIndex)}${this.selectedRating}${facetQuery.slice(totalIndex + 3)}`;
        }

        finalQuery = `:${selectedSortData}${facetQuery}&sort=${selectedSort}&page=${selectedPage}`;
      } else {
        finalQuery = `:${selectedSortData}${facetQuery}:averageReview:${this.selectedRating}&sort=${selectedSort}&page=${selectedPage}`;
      }
    } else {
      finalQuery = `:${selectedSortData}${facetQuery}&sort=${selectedSort}&page=${selectedPage}`;
    }

    return finalQuery;
  },

  // All click events on facets
  facetsClickEvents() {
    let queryToSend = '';
    $('body').on('click keypress', '.facet-checkbox', (e) => {
      if (e.currentTarget.checked) {
        const selectedSort = this.initialResponse.productCategorySearchPageData.sorts.filter(x => x.selected)[0].code;

        const currentQueryFromResponse = this.initialResponse.productCategorySearchPageData.currentQuery.query.value;
        const currentQueryFromFacet = e.currentTarget.dataset.truncatequery.split(selectedSort)[1];
        queryToSend = `${currentQueryFromResponse}${currentQueryFromFacet}`;
      } else {
        queryToSend = e.currentTarget.dataset.query;
      }
      const queryTest = this.getQuery(queryToSend, true);
      this.initialCLPDataLoad(queryTest, false);

      $('html, body').animate({
        scrollTop: $('.c-sorting-category').offset().top + ($('.c-sorting-category')[0].clientHeight - 100)
      }, 500);
      const checkboxId = e.currentTarget.id;
      setTimeout(() => {
        $(() => {
          $(`#${checkboxId}`).addClass('ada-highlighted');
          $(`#${checkboxId}`).focus();
        });
      }, 3000);
    });

    $('body').on('click keypress', '.remove-facet', (e) => {
      if ($(e.currentTarget).hasClass('facet-star-close')) {
        this.selectedRating = 0;
      }
      const filter = $(e.currentTarget).parents('.selected-tag').text();
      $(e.currentTarget).parents('.tag-wrap').find('.sr-only').empty()
        .text(`removed filter ${filter}`);
      const query = this.getQuery(e.currentTarget.dataset.query);
      this.initialCLPDataLoad(query, false);
    });

    $('body').on('keypress', '.facet-header', (e) => {
      $(e.currentTarget).trigger('click');
    });

    $('body').on('click keypress', '.c-plp-products-ajax .btn-red.general-add-to-cart-btn', (event) => {
      const pageType = $('#pagetype').data('pagetype');
      if (pageType === 'CATEGORY') {
        const productPosition = Number($(event.target).data('productposition')) + 1;
        const pageNumber = Number($(event.target).data('currentpage')) + 1;
        const categoryName = $(event.target).data('sascategorycode');
        localStorage.setItem('productposition', productPosition);
        localStorage.setItem('pageNumber', pageNumber);
        localStorage.setItem('sascategorycode', categoryName);
      }
    });
  },

  isFeaturedPill(productTileData) {
    if (((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel') && productTileData.shoreExData !== null && productTileData.shoreExData.isFeatured === true)
      || ((productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && productTileData.diningData !== null && productTileData.diningData.isFeatured === true)
      || ((productTileData.itemType === 'SpaProduct' || productTileData.itemType === 'SpaProductModel') && productTileData.spaData !== null && productTileData.spaData.isFeatured === true)) {
      return true;
    }
    return false;
  },

  isNewPill(productTileData) {
    if (((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel') && productTileData.shoreExData !== null && productTileData.shoreExData.isNew === true)
      || ((productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && productTileData.diningData !== null && productTileData.diningData.isNew === true)
      || ((productTileData.itemType === 'SpaProduct' || productTileData.itemType === 'SpaProductModel') && productTileData.spaData !== null && productTileData.spaData.isNew === true)) {
      return true;
    }
    return false;
  },

  isDiscounteligiblePill(productTileData) {
    if ((productTileData.itemType === 'SpaProduct' || productTileData.itemType === 'SpaProductModel') && productTileData.spaData !== null && productTileData.spaData.discountEligible === true) {
      return true;
    }
    return false;
  },

  isSoldOutPill(productTileData, response) {
    let isStockAvailable = true;
    if (productTileData.stock && productTileData.stock.stockLevelStatus && productTileData.stock.stockLevelStatus.code === 'outOfStock') {
      isStockAvailable = false;
    }
    if (response.userFlowType && (response.userFlowType !== 'BROWSE' && response.userFlowType !== 'LOGGED_IN_BROWSE')) {
      /* eslint-disable */
      if (!isStockAvailable && (productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel' || (productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && (productTileData.productType.code === 'DI' || productTileData.productType.code === 'XD'))) {
        return true;
      }
      /* eslint-enable */
    }
    return false;
  },

  tilesRating(averageRating, productCode) {
    let html = '';
    for (let i = 1; i <= 5; i++) {
      if (i <= averageRating) {
        html += ` <span> <img src="/_ui/responsive/ccl/assets/icons/star_filled.svg" width="12" height="11" alt="rating">
      </span>`;
      }
      if (i > averageRating) {
        if (i - 1 <= averageRating) {
          html += ` <span> <img src="/_ui/responsive/ccl/assets/icons/starhalf.svg" width="12" height="11" alt="rating">
        </span>`;
        } else {
          html += ` <span> <img src="/_ui/responsive/ccl/assets/icons/star_empty.svg" width="12" height="11" alt="rating">
        </span>`;
        }
      }
    }

    return html;
  },

  priceHtml(val, response) {
    const { itemType } = val;
    let price = {};
    // if it is shoreEx product
    if (itemType !== null && (itemType === 'ShoreExProduct' || itemType === 'ShoreExProductModel') && val.shoreExData !== null) {
      price = this.shorexPriceHtml(val, response);
    } else if (itemType !== null && (itemType === 'SpaProduct' || itemType === 'SpaProductModel')) {
      price = this.spaPriceHTML(val, response);
    } else if ((itemType !== null) && ((itemType === 'FunShopProduct' || itemType === 'FunShopProductModel') || (itemType === 'FunShopVariantProduct' || itemType === 'FunShopVariantProductModel'))) {
      price = this.funshopPriceHTML(val, response);
    } else if (itemType !== null && (itemType === 'DiningProduct' || itemType === 'DiningProductModel') && (val.productType.code === 'DI')) {
      price = this.diningPriceHTML(val, response);
    } else if (itemType !== null && (itemType === 'DiningProduct' || itemType === 'DiningProductModel') && (val.productType.code === 'XD')) {
      price = this.xDiningPriceHTML(val, response);
    }
    return price;
  },

  promotionPricingAjax(initialResData) {
    const token = $('#csrfSessionToken').data('csrf');
    const promoUrl = $('#promotionURL').data('promotionurl');
    let ajaxUrl = promoUrl;
    let ajaxType = 'POST';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/ajax-clp/promo-price.json';
      ajaxType = 'GET';
    }
    const products = [];
    let promotionalSailingData = '';
    if ($('#maskedSailingData').length && $('#maskedSailingData').data('sailingdata') !== '') {
      promotionalSailingData = JSON.parse(JSON.stringify($('#maskedSailingData').data('sailingdata')));
    }
    if (initialResData && initialResData.productCategorySearchPageData && initialResData.productCategorySearchPageData.results.length) {
      $.each(initialResData.productCategorySearchPageData.results, (key, val) => {
        let prodCode = val.code;
        let salesPerUnitDescription = null;
        if (val.itemType === 'ShoreExProduct' && val.shoreExData) {
          prodCode = val.shoreExData.variantData.skuCode;
          salesPerUnitDescription = val.shoreExData && val.shoreExData.salesPerUnitDescription ? val.shoreExData.salesPerUnitDescription : null;
        } else if (val.itemType === 'FunShopProduct' && val.funShopData) {
          prodCode = val.funShopData && val.funShopData.variantCode ? val.funShopData.variantCode : prodCode;
          salesPerUnitDescription = val.funShopData && val.funShopData.salesPerUnitDescription ? val.funShopData.salesPerUnitDescription : null;
        } else if (val.itemType === 'DiningProduct' && val.diningData && val.productType.code !== 'XD') {
          prodCode = val.diningData && val.diningData.variantData.skuCode ? val.diningData.variantData.skuCode : prodCode;
        }
        if (val.productType.code !== 'XD') {
          products.push({
            productCode: prodCode,
            productBaseCode: val.code,
            productType: val.productType.code,
            salesPerUnitDescription
          });
        }
      });
    }

    return $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      data: JSON.stringify({ products, promotionalSailingData })
    });
  },

  /* eslint-disable */
  shoreExPromoPriceHtml(productPromoData) {
    if (productPromoData.discountedPrice.length > 1) {
      // if both values are not same that means we have separate adult & child
      if (productPromoData.discountedPrice[0].value !== productPromoData.discountedPrice[1].value) {
        let adultHtml = '';
        let childHtml = '';
        const oldAdultPriceObj = productPromoData.originalPrice.filter(x => x.priceGroupType === 'A')[0];
        const oldChildPriceObj = productPromoData.originalPrice.filter(x => x.priceGroupType === 'C')[0];

        const newAdultPriceObj = productPromoData.discountedPrice.filter(x => x.priceGroupType === 'A')[0];
        const newChildPriceObj = productPromoData.discountedPrice.filter(x => x.priceGroupType === 'C')[0];

        adultHtml = `<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-ShoreExProduct"><span class="strikeoutprice greytext" aria-label="before the price was ${oldAdultPriceObj.formattedValue}" role="textbox"> <b>${oldAdultPriceObj.formattedValue}</b></span > / Adult</span ></p> <b aria-label="current price is ${newAdultPriceObj.formattedValue}" role="textbox">${newAdultPriceObj.formattedValue}</b></div>`;

        childHtml = `<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-ShoreExProduct"><span class="strikeoutprice greytext" aria-label="before the price was ${oldChildPriceObj.formattedValue}" role="textbox"> <b>${oldChildPriceObj.formattedValue}</b></span > / Child</span ></p> <b aria-label="current price is ${newChildPriceObj.formattedValue}" role="textbox">${newChildPriceObj.formattedValue}</b></div>`;

        $('body').find(`.${productPromoData.productBaseCode} .no-strike-adult`).replaceWith(adultHtml);
        $('body').find(`.${productPromoData.productBaseCode} .no-strike-child`).replaceWith(childHtml);
      } else {
        const priceHtml = `<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-ShoreExProduct"><span class="strikeoutprice greytext" aria-label="before the price was ${productPromoData.originalPrice[0].formattedValue}" role="textbox"><b>${productPromoData.originalPrice[0].formattedValue}</b></span> / Person</span></p></div><b aria-label="current price is ${productPromoData.discountedPrice[0].formattedValue}" role="textbox">${productPromoData.discountedPrice[0].formattedValue}</b>`;
        $('body').find(`.${productPromoData.productBaseCode} .single-row-price`).replaceWith(priceHtml);
      }
    } else {
      if (productPromoData.salesPerUnitDescription) {
        const priceHtml = `<div>
        <p class="price-person general-price-person ccl-d-inline-flex">
        <span class="general-price-ShoreExProduct">
        <span class="strikeoutprice greytext" aria-label="before the price was ${productPromoData.originalPrice[0].formattedValue}" role="textbox"><b>${productPromoData.originalPrice[0].formattedValue}</b></span> / ${productPromoData.salesPerUnitDescription}</span></p></div><b aria-label="current price is ${productPromoData.discountedPrice[0].formattedValue}" role="textbox"> ${productPromoData.discountedPrice[0].formattedValue}</b>`;
        $('body').find(`.${productPromoData.productBaseCode} .single-row-price`).replaceWith(priceHtml);
      } else {
        const priceHtml = `<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-ShoreExProduct"><span class="strikeoutprice greytext" aria-label="before the price was ${productPromoData.originalPrice[0].formattedValue}" role="textbox"><b>${productPromoData.originalPrice[0].formattedValue}</b></span> / Person</span></p></div><b aria-label="current price is ${productPromoData.discountedPrice[0].formattedValue}" role="textbox">${productPromoData.discountedPrice[0].formattedValue}</b>`;
        $('body').find(`.${productPromoData.productBaseCode} .single-row-price`).replaceWith(priceHtml);
      }
    }
  },

  funshopPromoPriceHTML(productPromoData) {
    let adultDiv = '';
    let childDiv = '';
    const salesPerUnitDescription = productPromoData.salesPerUnitDescription ? productPromoData.salesPerUnitDescription : '';
    if (productPromoData.discountedPrice.length > 1) {
      if (productPromoData.discountedPrice[0].value !== productPromoData.discountedPrice[1].value) {
        adultDiv = `<span class="general-price-FunShopProduct" aria-label="before the price was ${productPromoData.originalPrice[0].formattedValue}" role="textbox">
          <span class="strikeoutprice greytext">
          <b> ${productPromoData.originalPrice[0].formattedValue}</b>
          </span>
          ${salesPerUnitDescription}
          </span>
          <b aria-label="current price is ${productPromoData.discountedPrice[0].formattedValue}" role="textbox">
          ${productPromoData.discountedPrice[0].formattedValue}
          </b>`;
        $('body').find(`.${productPromoData.productBaseCode} .no-strike`).replaceWith(adultDiv);

        childDiv = `<span class="general-price-FunShopProduct" aria-label="before the price was ${productPromoData.originalPrice[1].formattedValue}" role="textbox">
        <span class="strikeoutprice greytext">
        <b>${productPromoData.originalPrice[1].formattedValue}</b>
        </span>
        ${salesPerUnitDescription}
        </span>
        ${parentPrice}
        <b aria-label="current price is ${productPromoData.discountedPrice[0].formattedValue}" role="textbox">${productPromoData.discountedPrice[0].formattedValue}</b>`;
        $('body').find(`.${productPromoData.productBaseCode} .no-strike-child`).replaceWith(childDiv);
      } else {
        adultDiv = `<span class="general-price-FunShopProduct" aria-label="before the price was ${productPromoData.originalPrice[0].formattedValue}" role="textbox">
          <span class="strikeoutprice greytext">
          <b> ${productPromoData.originalPrice[0].formattedValue}</b>
          </span>
          ${salesPerUnitDescription}
          </span>
          <b aria-label="current price is ${productPromoData.discountedPrice[0].formattedValue}" role="textbox">
          ${productPromoData.discountedPrice[0].formattedValue}
          </b>`;
        $('body').find(`.${productPromoData.productBaseCode} .no-strike`).replaceWith(adultDiv);
      }

      $('body').find(`.${productPromoData.productBaseCode} .btn-red`).attr('aria-label', `Add ${productPromoData.name} to the cart with price ${productPromoData.discountedPrice[0].formattedValue}`);
    } else {
      adultDiv = `<span class="general-price-FunShopProduct" aria-label="before the price was ${productPromoData.originalPrice[0].formattedValue}" role="textbox">
          <span class="strikeoutprice greytext">
          <b> ${productPromoData.originalPrice[0].formattedValue}</b>
          </span>
          ${salesPerUnitDescription}
          </span>
          <b aria-label="current price is ${productPromoData.discountedPrice[0].formattedValue}" role="textbox">
          ${productPromoData.discountedPrice[0].formattedValue}
          </b>`;
      $('body').find(`.${productPromoData.productBaseCode} .no-strike`).replaceWith(adultDiv);

      $('body').find(`.${productPromoData.productBaseCode} .btn-red`).attr('aria-label', `Add ${productPromoData.name} to the cart with price ${productPromoData.discountedPrice[0].formattedValue}`);
    }
  },


  shorexPriceHtml(val, response) {
    let priceDiv = '';
    let priceADA = '';
    if (response.userFlowType === null || (response.userFlowType !== null && response.userFlowType === 'BROWSE'
      || response.userFlowType === 'LOGGED_IN_BROWSE' || response.userFlowType === 'ORGANIZER')) {
      // price for any type of sales per unit
      if (val.shoreExData.salesPerUnitDescription !== null && val.shoreExData.basePriceData !== null) {
        priceDiv = `<div><p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span><span class="general-price-${val.itemType}"><b class="price-val">${val.shoreExData.basePriceData.formattedValue}</b> ${val.shoreExData.salesPerUnitDescription}</span></p></div>`;
        priceADA = `with price Starting At ${val.shoreExData.basePriceData.formattedValue} ${val.shoreExData.salesPerUnitDescription}`;
      } else if (val.shoreExData.basePriceData !== null && val.shoreExData.childBasePriceData !== null) {
        if (val.shoreExData.basePriceData.formattedValue === val.shoreExData.childBasePriceData.formattedValue) {
          // price when both base price and child are present but both are equal we show per person
          priceDiv = `<div><p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span><span class="general-price-${val.itemType}"><b class="person-price-val">${val.shoreExData.basePriceData.formattedValue}</b> / Person</span></p></div>`;

          priceADA = `with price Starting At ${val.shoreExData.basePriceData.formattedValue} per Person`;
        } else {
          // price when both base price and child are present but both are not equal we show per adult and per child
          priceDiv = `<p class="per-adult-starting-at"><span class="starting-at-cls starting-at general-starting-at">Starting At</span></p><div><span class="general-price-${val.itemType}"><b class="adult-price-val">${val.shoreExData.basePriceData.formattedValue}</b> / Adult</span></div><div><span class="general-price-${val.itemType}"><b class="child-price-val">${val.shoreExData.childBasePriceData.formattedValue}</b> / Child</span></div>`;
          priceADA = `with price Starting At ${val.shoreExData.basePriceData.formattedValue} per Adult and ${val.shoreExData.childBasePriceData.formattedValue} per Child`;
        }
      }
    } else {
      // when shoreEx variant data is present
      if (val.shoreExData.variantData !== null) {
        // price for any type of sales per unit
        if (val.shoreExData.salesPerUnitDescription !== null && val.shoreExData.variantData.basePriceData !== null) {
          // when strikeout price is present for variant data show both strikeout and persales description
          if (val.strikeOutPrice !== null && val.strikeOutPrice.value !== null
            && val.strikeOutPrice.value > 0) {
            priceDiv = `<div>
            <p class="price-person general-price-person ccl-d-inline-flex">
            <span class="general-price-${val.itemType}">
            <span class="strikeoutprice greytext" aria-label="before the price was ${val.strikeOutPrice.formattedValue}" role="textbox"><b>${val.strikeOutPrice.formattedValue}</b></span> / ${val.shoreExData.salesPerUnitDescription}</span></p></div><b aria-label="current price is ${val.shoreExData.variantData.basePriceData.formattedValue}" role="textbox"> ${val.shoreExData.variantData.basePriceData.formattedValue}</b>`;
            priceADA = `with price ${val.shoreExData.variantData.basePriceData.formattedValue} per ${val.shoreExData.salesPerUnitDescription}`;
          } else {
            // when strikeout is not present
            priceDiv = `<div class="single-row-price"><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-${val.itemType}"><b aria-label="current price is ${val.shoreExData.variantData.basePriceData.formattedValue}" role="textbox">${val.shoreExData.variantData.basePriceData.formattedValue}</b> / ${val.shoreExData.salesPerUnitDescription}</span></p></div>`;
            priceADA = `with price ${val.shoreExData.variantData.basePriceData.formattedValue} per ${val.shoreExData.salesPerUnitDescription}`;
          }
        } else if (val.shoreExData.variantData.basePriceData !== null
          && val.shoreExData.variantData.childBasePriceData !== null
          && val.shoreExData.variantData.basePriceData.formattedValue === val.shoreExData.variantData.childBasePriceData.formattedValue) {
          // sales per unit is not present and child price is equal to base price show per person price
          // when strikeout price is present
          if (val.strikeOutPrice !== null && val.strikeOutPrice.value !== null
            && val.strikeOutPrice.value > 0) {
            priceDiv = `<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-${val.itemType}"><span class="strikeoutprice greytext" aria-label="before the price was ${val.strikeOutPrice.formattedValue}" role="textbox"><b>${val.strikeOutPrice.formattedValue}</b></span> / Person</span></p></div><b aria-label="current price is ${val.shoreExData.variantData.basePriceData.formattedValue}" role="textbox">${val.shoreExData.variantData.basePriceData.formattedValue}</b>`;
            priceADA = `with price ${val.shoreExData.variantData.basePriceData.formattedValue} per Person`;
          } else {
            // when strikeout is not present
            priceDiv = `<div class="single-row-price"><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-${val.itemType}"><b aria-label="current price is ${val.shoreExData.variantData.basePriceData.formattedValue}" role="textbox">${val.shoreExData.variantData.basePriceData.formattedValue}</b> / Person</span></p></div>`;

            priceADA = `with price ${val.shoreExData.variantData.basePriceData.formattedValue} per Person`;
          }
        } else {
          // when both adult and child price are present and both are not equal
          const startDiv = '<div class="ccl-d-inline-flex">';
          const endDiv = '</div>';
          let adultDiv = '';
          let childDiv = '';
          // when strikeout price is present
          if (val.shoreExData.variantData.basePriceData !== null) {
            if (val.strikeOutPrice !== null && val.strikeOutPrice.value !== null && val.strikeOutPrice.value > 0) {
              adultDiv = `<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-${val.itemType}"><span class="strikeoutprice greytext" aria-label="before the price was ${val.strikeOutPrice.formattedValue}" role="textbox" > <b>${val.strikeOutPrice.formattedValue}</b></span > / Adult</span ></p > <b aria-label="current price is ${val.shoreExData.variantData.basePriceData.formattedValue}" role="textbox">${val.shoreExData.variantData.basePriceData.formattedValue}</b></div > `;
            } else {
              // when strikeout price is not present
              adultDiv = `<div class="no-strike-adult"><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-${val.itemType}"><b aria-label=" current price is ${val.shoreExData.variantData.basePriceData.formattedValue}" role = "textbox" > ${val.shoreExData.variantData.basePriceData.formattedValue}</b > / Adult</span ></p ></div >`;
            }
          }
          // when child strikeout price is present
          if (val.shoreExData.variantData.childBasePriceData !== null) {
            if (val.childStrikeOutPrice !== null && val.childStrikeOutPrice.value !== null && val.childStrikeOutPrice.value > 0) {
              childDiv = `<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-${val.itemType}"><span class="strikeoutprice greytext" aria-label="before the price was ${val.childStrikeOutPrice.formattedValue}" role = "textbox" > <b>${val.childStrikeOutPrice.formattedValue}</b></span > / Child</span ></p > <b aria-label="current price is ${val.shoreExData.variantData.childBasePriceData.formattedValue}" role="textbox">${val.shoreExData.variantData.childBasePriceData.formattedValue}</b></div >`;
            } else {
              // when child strikeout price is not present
              childDiv = `<div class="no-strike-child"><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-${val.itemType}"><b aria-label=" current price is ${val.shoreExData.variantData.childBasePriceData.formattedValue}" role = "textbox" > ${val.shoreExData.variantData.childBasePriceData.formattedValue}</b > / Child</span ></p ></div >`;
            }
          }
          priceDiv = startDiv + adultDiv + childDiv + endDiv;
          if (val.shoreExData.variantData.basePriceData !== null && val.shoreExData.variantData.childBasePriceData !== null) {
            priceADA = `with price ${val.shoreExData.variantData.basePriceData.formattedValue} per adult and ${val.shoreExData.variantData.childBasePriceData.formattedValue} per child`;
          }
        }
      }
    }
    priceDiv = `${priceDiv}`;
    return { priceDiv, priceADA };
  },

  // Get price HTML for SPA
  spaPriceHTML(val, response) {
    let priceDiv = '';
    let priceADA = '';
    if (val.price !== null && val.price.formattedValue !== null) {
      // price when both base price and child are present but both are equal we show per person
      priceDiv = `<div><p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span><span class="general-price-${val.itemType}"><b>${val.price.formattedValue}</b> </span></p></div>`;

      priceADA = `with price Starting At ${val.price.formattedValue}`;
    }

    return { priceDiv, priceADA };
  },

  // Get price HTML for Funshop
  funshopPriceHTML(productData, response) {
    let priceDiv = '';
    let priceADA = '';
    const startDiv = '<p class="price-person general-price-person ccl-d-inline-flex">';
    const endDiv = '</p>';
    let adultDiv = '';
    let childDiv = '';

    const salesPerUnitDescription = productData.funShopData.salesPerUnitDescription ? `/${productData.funShopData.salesPerUnitDescription}` : '';

    const childSalesPerUnitDescription = productData.funShopData.childSalesPerUnitDescription ? `/ ${productData.funShopData.childSalesPerUnitDescription}` : '';

    const parentPrice = productData.price ? '<span class="general-pipe-separator pipe-separator"> | </span>' : '';

    let hasVariant = (productData.hasVariant === 'FALSE' || (productData.category && productData.category.trim() === 'Bottomless Bubbles Package')) ? '' : 'Starting From';

    if (response.userFlowType !== null && (productData.browseModePrice && productData.browseModePrice !== null) && (response.userFlowType === 'BROWSE' || response.userFlowType === 'LOGGED_IN_BROWSE')) {
      adultDiv = `<span class="general-price-${productData.itemType} text general-starting-at"  aria-label="current price Starting At ${productData.browseModePrice.formattedValue}" role="textbox">
      <div>Starting At</div>
      <b>${productData.browseModePrice.formattedValue}</b>
      ${salesPerUnitDescription}
      </span>`;


      hasVariant = 'Starting At'
      productData.price.formattedValue = productData.browseModePrice.formattedValue;
    } else {
      if (productData.childBasePrice !== null) {

        if (productData.childStrikeOutPrice !== null
          && productData.childStrikeOutPrice.value !== null
          && productData.childStrikeOutPrice.value > 0) {

          childDiv = `<span class="general-price-${productData.itemType}" aria-label="before the price was ${productData.childStrikeOutPrice.formattedValue}" role="textbox">
              <span class="strikeoutprice greytext">
              <b>${productData.childStrikeOutPrice.formattedValue}</b>
              </span>
              ${childSalesPerUnitDescription}
            </span>
            ${parentPrice}
            <b aria-label="current price is ${productData.childBasePrice.childFormattedPrice}" role="textbox">${productData.childBasePrice.childFormattedPrice}</b>`;
        } else {
          childDiv = `<span class="general-price-${productData.itemType} no-strike-child">
          <b aria-label="Current price is ${productData.childBasePrice.childFormattedPrice}" role="textbox">
          ${productData.funShopData.childBasePrice.childFormattedPrice}
          </b>
          ${childSalesPerUnitDescription}
          </span>
          ${parentPrice}`;
        }
      } else if (productData.price !== null) {
        if ((productData.strikeOutPrice !== null
          && productData.strikeOutPrice.value !== null
          && productData.strikeOutPrice.value > 0)) {
          adultDiv = `<span class="general-price-${productData.itemType}" aria-label="before the price was ${productData.strikeOutPrice.formattedValue}" role="textbox">
            ${hasVariant}
            <span class="strikeoutprice greytext">
            <b> ${productData.strikeOutPrice.formattedValue}</b>
            </span>
            ${salesPerUnitDescription}
            </span>
            <b aria-label="current price is ${productData.price.formattedValue}" role="textbox">
            ${productData.price.formattedValue}
            </b>`;
        } else {
          adultDiv = `<span class="general-price-${productData.itemType} no-strike" aria-label="current price is ${productData.price.formattedValue}" role="textbox">
          ${hasVariant}
          <b>${productData.price.formattedValue}</b>
          ${salesPerUnitDescription}
          </span>`;
        }
      }
    }


    const priceLabel = productData.strikeOutPrice ? productData.strikeOutPrice.formattedValue : productData.price.formattedValue;
    priceDiv = startDiv + adultDiv + childDiv + endDiv;
    priceADA = `with price ${hasVariant} ${priceLabel} ${salesPerUnitDescription}`;

    return { priceDiv, priceADA };
  },

  // Get price HTML for Dining
  diningPriceHTML(productTileData, response) {
    let priceDiv = '';
    let priceADA = '';
    let adultDiv = '';
    let childDiv = '';
    if (response.userFlowType !== null && (response.userFlowType === 'BROWSE' || response.userFlowType === 'LOGGED_IN_BROWSE')) {
      if ((productTileData.diningData.basePriceData !== null && productTileData.diningData.childBasePriceData !== null && productTileData.diningData.basePriceData.formattedValue === productTileData.diningData.childBasePriceData.formattedValue) || productTileData.diningData.basePriceData !== null && !productTileData.diningData.childBasePriceData) {

        priceDiv = `<div><p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span><span class="general-price-${productTileData.itemType}"><b>${productTileData.diningData.basePriceData.formattedValue}</b> / Person</span></p></div>`;

        priceADA = `with price Starting At ${productTileData.diningData.basePriceData.formattedValue} Per Person`;
      } else {
        priceDiv = `<p class="per-adult-starting-at"><span class="starting-at-cls starting-at general-starting-at">Starting At</span></p><div><span class="general-price-${productTileData.itemType}"><b>${productTileData.diningData.basePriceData.formattedValue}</b> / Adult</span></div><div><span class="general-price-${productTileData.itemType}"><b>${productTileData.diningData.childBasePriceData.formattedValue}</b> / Child</span></div>`;
        priceADA = `with price Starting At ${productTileData.diningData.basePriceData.formattedValue} per Adult and ${productTileData.diningData.childBasePriceData.formattedValue} per Child`;
      }
    }
    if (response.userFlowType === 'LOGGED_IN_BUY' || response.userFlowType === 'FUNMAIL') {
      if (productTileData.diningData.variantData.basePriceData !== null && productTileData.diningData.variantData.childBasePriceData !== null && productTileData.diningData.variantData.basePriceData.formattedValue === productTileData.diningData.variantData.childBasePriceData.formattedValue) {
        if ((productTileData.strikeOutPrice !== null
          && productTileData.strikeOutPrice.value !== null
          && productTileData.strikeOutPrice.value > 0
          && productTileData.diningData.variantData.basePriceData.formattedValue !== productTileData.strikeOutPrice.formattedValue)) {

          priceDiv = `<div>
						<p class="per-person-starting-at ccl-d-inline-flex"><span class="starting-at-cls general-starting-at">Starting At</span>
							<span class="general-price-${productTileData.itemType}">
              <span class="strikeoutprice greytext" aria-label="before the price was ${productTileData.strikeOutPrice.formattedValue}" role="textbox">
              <b>${productTileData.strikeOutPrice.formattedValue}</b>
              </span>
							/ Person
							</span>
						</p>
          </div>
          <b aria-label="current price is ${productTileData.diningData.variantData.basePriceData.formattedValue}" role="textbox"> ${productTileData.diningData.variantData.basePriceData.formattedValue}</b>`;

          priceADA = `with price Starting At ${productTileData.diningData.variantData.basePriceData.formattedValue} per person`;
        } else {
          priceDiv = `<div class="single-row-price">
						<p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span>
              <span class="general-price-${productTileData.itemType}">
              <b aria-label=" current price is ${productTileData.diningData.variantData.basePriceData.formattedValue}" role = "textbox" > ${productTileData.diningData.variantData.basePriceData.formattedValue}</b > / Person
							</span>
						</p>
          </div>`;
          priceADA = `with price Starting At ${productTileData.diningData.variantData.basePriceData.formattedValue} per person`;
        }

      } else if (productTileData.diningData.variantData.basePriceData !== null && !productTileData.diningData.variantData.childBasePriceData) {
        if (productTileData.strikeOutPrice !== null && productTileData.strikeOutPrice.value > 0
           && productTileData.diningData.variantData.basePriceData.formattedValue !== productTileData.strikeOutPrice.formattedValue) {
          priceDiv = `<div>
            <p class="per-person-starting-at ccl-d-inline-flex"><span class="starting-at-cls general-starting-at">Starting At</span>
              <span class="general-price-${productTileData.itemType}">
              <span class="strikeoutprice greytext" aria-label="before the price was ${productTileData.strikeOutPrice.formattedValue}" role="textbox">
              <b>${productTileData.strikeOutPrice.formattedValue}</b>
              </span>
              / Person
              </span>
          </div>
          <b aria-label="current price is ${productTileData.diningData.variantData.basePriceData.formattedValue}" role="textbox"> ${productTileData.diningData.variantData.basePriceData.formattedValue}</b>`;

          priceADA = `with price Starting At ${productTileData.diningData.variantData.basePriceData.formattedValue} per person`;
        } else {

          priceDiv = `<div class="single-row-price">
						<p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span>
              <span class="general-price-${productTileData.itemType}">
              <b aria-label=" current price is ${productTileData.diningData.variantData.basePriceData.formattedValue}" role="textbox"> ${productTileData.diningData.variantData.basePriceData.formattedValue}</b> / Person
							</span>
						</p>
          </div>`;
          priceADA = `with price Starting At ${productTileData.diningData.variantData.basePriceData.formattedValue} per person`;
        }
      } else {
        if (productTileData.strikeOutPrice !== null && productTileData.strikeOutPrice.value > 0
          && productTileData.diningData.variantData.basePriceData.formattedValue !== productTileData.strikeOutPrice.formattedValue) {

          adultDiv = `<div>
            <p class="per-adult-starting-at ccl-d-inline-flex">
            <span class="starting-at general-starting-at">Starting At</span>
						<span class="general-price-${productTileData.itemType}">
            <span class="strikeoutprice greytext" aria-label="before the price was ${productTileData.strikeOutPrice.formattedValue}" role="textbox">
            <b>${productTileData.strikeOutPrice.formattedValue}</b>
            </span>
							/ Adult
						</span>
          </div>
          <b aria-label="current price is ${productTileData.diningData.variantData.basePriceData.formattedValue}" role="textbox"> ${productTileData.diningData.variantData.basePriceData.formattedValue}</b>`;

        } else {

          adultDiv = `
            <p class="per-adult-starting-at"><span class="starting-at general-starting-at">Starting At</span></p>
            <div class="no-strike-adult">
						<span class="general-price-${productTileData.itemType}">
							<b aria-label="Currrent price is ${productTileData.diningData.variantData.basePriceData.formattedValue}" role="textbox">${productTileData.diningData.variantData.basePriceData.formattedValue}</b>
							/ Adult
            </span>
            </div>
					`;
        }

        if (productTileData.childStrikeOutPrice !== null && productTileData.childStrikeOutPrice.value > 0
          && productTileData.diningData.variantData.basePriceData.formattedValue !== productTileData.strikeOutPrice.formattedValue) {

          childDiv = `<div>
            <p class="per-child-starting-at ccl-d-inline-flex">
						<span class="general-price-${productTileData.itemType}">
            <span class="strikeoutprice greytext" aria-label="before the price was ${productTileData.childStrikeOutPrice.formattedValue}" role="textbox">
            <b>${productTileData.childStrikeOutPrice.formattedValue}</b>
            </span>
							/ Child
						</span>
          </div>
          <b aria-label="current price is ${productTileData.diningData.variantData.childBasePriceData.formattedValue}" role="textbox"> ${productTileData.diningData.variantData.childBasePriceData.formattedValue}</b>`;

        } else {
          childDiv = `<div class="no-strike-child">
          <span class="general-price-${productTileData.itemType}" aria-label="Current price is ${productTileData.diningData.variantData.childBasePriceData.formattedValue}role="textbox">
            <b>${productTileData.diningData.variantData.childBasePriceData.formattedValue}</b>
            / Child
          </span>
        </div>`;
        }

        priceDiv = adultDiv + childDiv;

        priceADA = `with price Starting At ${productTileData.diningData.variantData.basePriceData.formattedValue} per adult and ${productTileData.diningData.variantData.childBasePriceData.formattedValue} per child`;
      }
    }


    return { priceDiv, priceADA };
  },

  // Get price HTML for xDining
  xDiningPriceHTML(productTileData, response) {
    let priceDiv = '';
    let priceADA = '';
    let adultDiv = '';
    let childDiv = '';
    if (response.userFlowType !== null && (response.userFlowType === 'BROWSE' || response.userFlowType === 'LOGGED_IN_BROWSE')) {
      if ((productTileData.diningData.basePriceData !== null && productTileData.diningData.childBasePriceData !== null && productTileData.diningData.basePriceData.formattedValue === productTileData.diningData.childBasePriceData.formattedValue) || productTileData.diningData.basePriceData !== null && !productTileData.diningData.childBasePriceData) {

        priceDiv = `<div><p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span><span class="general-price-${productTileData.itemType}"><b>${productTileData.diningData.basePriceData.formattedValue}</b> / Person</span></p></div>`;

        priceADA = `with price Starting At ${productTileData.diningData.basePriceData.formattedValue} Per Person`;
      } else {
        priceDiv = `<p class="per-adult-starting-at"><span class="starting-at-cls starting-at general-starting-at">Starting At</span></p><div><span class="general-price-${productTileData.itemType}"><b>${productTileData.diningData.basePriceData.formattedValue}</b> / Adult</span></div><div><span class="general-price-${productTileData.itemType}"><b>${productTileData.diningData.childBasePriceData.formattedValue}</b> / Child</span></div>`;
        priceADA = `with price Starting At ${productTileData.diningData.basePriceData.formattedValue} per Adult and ${productTileData.diningData.childBasePriceData.formattedValue} per Child`;
      }
    }
    if (response.userFlowType === 'LOGGED_IN_BUY' || response.userFlowType === 'FUNMAIL') {
      if (productTileData.diningData.basePriceData !== null && productTileData.diningData.childBasePriceData !== null && productTileData.diningData.basePriceData.formattedValue === productTileData.diningData.childBasePriceData.formattedValue) {
        if ((productTileData.strikeOutPrice !== null
          && productTileData.strikeOutPrice.value !== null
          && productTileData.strikeOutPrice.value > 0)) {

          if (productTileData.strikeOutPrice.value !== productTileData.childStrikeOutPrice.value) {
            adultDiv = `<div>
              <p class="per-adult-starting-at ccl-d-inline-flex">
              <span class="starting-at general-starting-at">Starting At</span>
              <span class="general-price-${productTileData.itemType}">
              <span class="strikeoutprice greytext" aria-label="before the price was ${productTileData.strikeOutPrice.formattedValue}" role="textbox">
              <b>${productTileData.strikeOutPrice.formattedValue}</b>
              </span>
                / Adult
              </span>
            </div>
            <b aria-label="current price is ${productTileData.diningData.basePriceData.formattedValue}" role="textbox"> ${productTileData.diningData.basePriceData.formattedValue}</b>`;

            childDiv = `<div>
            <p class="per-child-starting-at ccl-d-inline-flex">
						<span class="general-price-${productTileData.itemType}">
            <span class="strikeoutprice greytext" aria-label="before the price was ${productTileData.childStrikeOutPrice.formattedValue}" role="textbox">
            <b>${productTileData.childStrikeOutPrice.formattedValue}</b>
            </span>
							/ Child
						</span>
          </div>
          <b aria-label="current price is ${productTileData.diningData.childBasePriceData.formattedValue}" role="textbox"> ${productTileData.diningData.childBasePriceData.formattedValue}</b>`

            priceDiv = adultDiv + childDiv;
          } else {
            priceDiv = `<div>
              <p class="per-person-starting-at ccl-d-inline-flex"><span class="starting-at-cls general-starting-at">Starting At</span>
                <span class="general-price-${productTileData.itemType}">
                <span class="strikeoutprice greytext" aria-label="before the price was ${productTileData.strikeOutPrice.formattedValue}" role="textbox">
                <b>${productTileData.strikeOutPrice.formattedValue}</b>
                </span>
                / Person
                </span>
              </p>
            </div>
            <b aria-label="current price is ${productTileData.diningData.basePriceData.formattedValue}" role="textbox"> ${productTileData.diningData.basePriceData.formattedValue}</b>`;

            priceADA = `with price Starting At ${productTileData.diningData.basePriceData.formattedValue} per person`;
          }

        } else {
          priceDiv = `<div>
						<p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span>
              <span class="general-price-${productTileData.itemType}">
              <b aria-label=" current price is ${productTileData.diningData.basePriceData.formattedValue}" role = "textbox" > ${productTileData.diningData.basePriceData.formattedValue}</b > / Person
							</span>
						</p>
          </div>`;
          priceADA = `with price Starting At ${productTileData.diningData.basePriceData.formattedValue} per person`;
        }

      } else if (productTileData.diningData.basePriceData !== null && !productTileData.diningData.childBasePriceData) {
        if (productTileData.strikeOutPrice !== null && productTileData.strikeOutPrice !== null && productTileData.strikeOutPrice.value > 0) {
          priceDiv = `<div>
            <p class="per-person-starting-at ccl-d-inline-flex"><span class="starting-at-cls general-starting-at">Starting At</span>
              <span class="general-price-${productTileData.itemType}">
              <span class="strikeoutprice greytext" aria-label="before the price was ${productTileData.strikeOutPrice.formattedValue}" role="textbox">
              <b>${productTileData.strikeOutPrice.formattedValue}</b>
              </span>
              / Person
              </span>
            </p>
          </div>
          <b aria-label="current price is ${productTileData.diningData.basePriceData.formattedValue}" role="textbox"> ${productTileData.diningData.basePriceData.formattedValue}</b>`;

          priceADA = `with price Starting At ${productTileData.diningData.basePriceData.formattedValue} per person`;
        } else {

          priceDiv = `<div>
						<p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span>
              <span class="general-price-${productTileData.itemType}">
              <b aria-label=" current price is ${productTileData.diningData.basePriceData.formattedValue}" role="textbox"> ${productTileData.diningData.basePriceData.formattedValue}</b> / Person
							</span>
						</p>
          </div>`;
          priceADA = `with price Starting At ${productTileData.diningData.basePriceData.formattedValue} per person`;
        }
      } else {
        if (productTileData.strikeOutPrice !== null && productTileData.strikeOutPrice.value > 0) {

          adultDiv = `<div>
            <p class="per-adult-starting-at ccl-d-inline-flex">
            <span class="starting-at general-starting-at">Starting At</span>
						<span class="general-price-${productTileData.itemType}">
            <span class="strikeoutprice greytext" aria-label="before the price was ${productTileData.strikeOutPrice.formattedValue}" role="textbox">
            <b>${productTileData.strikeOutPrice.formattedValue}</b>
            </span>
							/ Adult
						</span>
          </div>
          <b aria-label="current price is ${productTileData.diningData.basePriceData.formattedValue}" role="textbox"> ${productTileData.diningData.basePriceData.formattedValue}</b>`;

        } else {

          adultDiv = `
            <p class="per-adult-starting-at"><span class="starting-at general-starting-at">Starting At</span></p>
            <div>
						<span class="general-price-${productTileData.itemType}">
							<b aria-label="Currrent price is ${productTileData.diningData.basePriceData.formattedValue}" role="textbox">${productTileData.diningData.basePriceData.formattedValue}</b>
							/ Adult
            </span>
            </div>
					`;
        }

        if (productTileData.childStrikeOutPrice !== null && productTileData.childStrikeOutPrice.value > 0) {

          childDiv = `<div>
            <p class="per-child-starting-at ccl-d-inline-flex">
						<span class="general-price-${productTileData.itemType}">
            <span class="strikeoutprice greytext" aria-label="before the price was ${productTileData.childStrikeOutPrice.formattedValue}" role="textbox">
            <b>${productTileData.childStrikeOutPrice.formattedValue}</b>
            </span>
							/ Child
						</span>
          </div>
          <b aria-label="current price is ${productTileData.diningData.childBasePriceData.formattedValue}" role="textbox"> ${productTileData.diningData.childBasePriceData.formattedValue}</b>`;

        } else {
          childDiv = `<div>
          <span class="general-price-${productTileData.itemType}" aria-label="Current price is ${productTileData.diningData.childBasePriceData.formattedValue}role="textbox">
            <b>${productTileData.diningData.childBasePriceData.formattedValue}</b>
            / Child
          </span>
        </div>`;
        }

        priceDiv = adultDiv + childDiv;

        priceADA = `with price Starting At ${productTileData.diningData.basePriceData.formattedValue} per adult and ${productTileData.diningData.childBasePriceData.formattedValue} per child`;
      }
    }


    return { priceDiv, priceADA };
  },

  addToCartBtnClasses(productTileData, response) {
    /** SETTING UP SOME INITIAL VARIABLES START */
    const CSRFToken = $('#csrfSessionToken').data('csrf');
    let addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-add-cart btn-full';
    let addToCartBtnAttributes = '';
    const addToCartUniqueClass = `add-to-cart-${productTileData.code}`;

    // check if product is FTF
    let isFTFProduct = false;
    if ((productTileData.shoreExData) &&
      (productTileData.shoreExData.variantData) &&
      (productTileData.rootCategoryName) &&
      (productTileData.rootCategoryName.toLowerCase().replace(' ', '-') === 'faster-to-the-fun')) {
      isFTFProduct = true;
    }
    if(response.productCategorySearchPageData){
      const categoryCode = response.productCategorySearchPageData.categoryCode;
      if(categoryCode.toLowerCase() === 'faster-to-the-fun'){
        isFTFProduct = true;
      }
    }

    // check if product if FunshopProduct
    let isInternetProduct = false;
    if ((productTileData.itemType === 'FunShopProduct' || productTileData.itemType === 'FunShopProductModel') && (productTileData.rootCategoryName)
      && (productTileData.rootCategoryName.toLowerCase().replace(' ', '-') === 'internet-plans')) {
      isInternetProduct = true;
    }

    // check if product is drinkPackage product
    let isDrinkPackageProduct = false;
    if ((productTileData.itemType === 'FunShopProduct' || productTileData.itemType === 'FunShopProductModel') && (productTileData.rootCategoryName)
      && (productTileData.rootCategoryName.toLowerCase().replace(' ', '-') === 'drink-packages')) {
      isDrinkPackageProduct = true;
    }

    // Getting correct prodCode of different product type
    let prodCode = productTileData.code;
    if ((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel') && productTileData.shoreExData && productTileData.shoreExData.variantData) {
      prodCode = productTileData.shoreExData.variantData.skuCode;
    } else if ((productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && productTileData.diningData && productTileData.diningData.variantData) {
      prodCode = productTileData.diningData.variantData.skuCode;
    } else {
      prodCode = productTileData.code;
    }

    // Check if product has variant
    let hasProductVariant = false;
    if (productTileData.hasVariant === 'TRUE') {
      hasProductVariant = true;
    }

    // check for stock availibility
    let isStockAvailable = true;
    if (productTileData.stock && productTileData.stock.stockLevelStatus && productTileData.stock.stockLevelStatus.code === 'outOfStock') {
      isStockAvailable = false;
    }
    /** SETTING UP SOME INITIAL VARIABLES END */


    if ((response.allBookingsOnCourtesyHold || productTileData.addToCartDisabled || !isStockAvailable) && response.userFlowType !== null && response.userFlowType !== 'BROWSE' && response.userFlowType !== 'LOGGED_IN_BROWSE' && (productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel' || isFTFProduct === true || ((productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel'))) && productTileData.itemType !== 'TransfersProduct' && productTileData.itemType !== 'TransfersProductModel') {
      // If All booking CourtesyHold & stock not available
      addToCartBtnClass = `btn btn-red general-add-to-cart-btn btn-full ${addToCartUniqueClass}`;
      addToCartBtnAttributes = 'disabled="disabled"';
    } else if (((response.allBookingsOnCourtesyHold || productTileData.addToCartDisabled) && (response.userFlowType !== null && (response.userFlowType !== 'BROWSE' && response.userFlowType !== 'LOGGED_IN_BROWSE')) && (productTileData.itemType !== 'ShoreExProduct' && productTileData.itemType !== 'ShoreExProductModel') && isFTFProduct === false) && ((productTileData.itemType !== 'TransfersProduct' && productTileData.itemType !== 'TransfersProductModel'))) {
      // If All booking CourtesyHold
      addToCartBtnClass = `btn btn-red general-add-to-cart-btn btn-full ${addToCartUniqueClass}`;
      addToCartBtnAttributes = 'disabled="disabled"';
    } else if (((response.userFlowType && response.userFlowType === 'BROWSE') || (response.userFlowType === null)) && (productTileData.itemType !== 'TransfersProduct' && productTileData.itemType !== 'TransfersProductModel')) {
      // if BROWSE Mode
      addToCartBtnClass = `btn btn-red general-add-to-cart-btn btn-add-cart btn-full ${addToCartUniqueClass}`;
      addToCartBtnAttributes = `data-productcode="${productTileData.code}"
                                data-csrf="${CSRFToken}"
                                data-usermode="browse"
                                data-funshopcategorycode="${response.categoryCode}"
                                data-hasVariants="${hasProductVariant}"
                                data-sailingInfoNeeded="${productTileData.sailingInfoNeeded}"`;
    } else if (response.userFlowType !== null && response.userFlowType === 'LOGGED_IN_BROWSE') {
      // if LOGGED_IN_BROWSE mode
      addToCartBtnClass = `btn btn-red general-add-to-cart-btn btn-add-cart btn-full ${addToCartUniqueClass}`;
      addToCartBtnAttributes = `data-productcode="${productTileData.code}"
                                data-hasvariants="${hasProductVariant}"
                                data-csrf="${CSRFToken}"
                                data-usermode="loggedInBrowse"
                                data-funshopcategorycode="${response.categoryCode}"
                                data-sailingInfoNeeded="${productTileData.sailingInfoNeeded}"`;
    } else {
      if ((productTileData.itemType === 'SpaProduct' || productTileData.itemType === 'SpaProductModel')) {
        // if is SPA product
        addToCartBtnClass = `btn btn-full btn-red general-add-to-cart-btn calendarOpenBtn modalOpenBtn${prodCode} ${addToCartUniqueClass}`;
        addToCartBtnAttributes = `data-productcode="${prodCode}"
                                  data-csrf="${CSRFToken}"`;
      } else if ((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel') && (isFTFProduct === true)) {
        // if is ShoreEX FTF product
        addToCartBtnClass = `btn btn-red general-add-to-cart-btn btn-full clp-add-to-cart-btn ${addToCartUniqueClass}`;
        addToCartBtnAttributes = `data-csrf="${CSRFToken}"
                                  data-productcode="${prodCode}"`;
      } else if ((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel') && (isFTFProduct === false)) {
        // ShoreEx but not FTF product
        addToCartBtnClass = `btn btn-red general-add-to-cart-btn btn-full checkoutConflictBtn ${addToCartUniqueClass}`;
        addToCartBtnAttributes = `data-csrf="${CSRFToken}"
                                  data-productcode="${prodCode}"
										              data-hasupsell="${productTileData.hasUpsell}"`;
      } else if ((productTileData.itemType === 'FunShopProduct' || productTileData.itemType === 'FunShopProductModel') && (productTileData.isFunshopAlchohol === true || productTileData.isFunshopPackage === true)) {
        // Fun shop alcohol product
        addToCartBtnClass = `btn btn-red general-add-to-cart-btn btn-full alcohol-atc-modal-open-button ${addToCartUniqueClass}"`;
        addToCartBtnAttributes = `data-productcode="${productTileData.code}"
                                data-csrf="${CSRFToken}"
                                data-usermode="loggedInBuy"
										            data-sailingInfoNeeded="${productTileData.sailingInfoNeeded}"`;
      } else if (isInternetProduct === true) {
        // internet product
        addToCartBtnClass = `btn btn-red general-add-to-cart-btn btn-full clp-add-to-cart-btn ${addToCartUniqueClass}`;
        addToCartBtnAttributes = `data-csrf="${CSRFToken}"
                                data-hasvariants="${hasProductVariant}"
										            data-productcode="${productTileData.code}"`;
      } else if (isDrinkPackageProduct === true) {
        addToCartBtnClass = `btn btn-red general-add-to-cart-btn btn-full clp-add-to-cart-btn ${addToCartUniqueClass}`;
        addToCartBtnAttributes = `data-csrf="${CSRFToken}"
                                data-hasvariants="${hasProductVariant}"
                                data-productcode="${productTileData.code}"`;
      } else if ((productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && productTileData.productType.code === 'DI') {
        addToCartBtnClass = `btn btn-red general-add-to-cart-btn btn-full dining-atc-modal-open-button ${addToCartUniqueClass}`;
        addToCartBtnAttributes = `data-productcode="${productTileData.code}"
                                data-csrf="${CSRFToken}"
                                data-usermode="loggedInBuy"
                                data-sailingInfoNeeded="${productTileData.sailingInfoNeeded}"`;
      } else if ((productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && productTileData.productType.code === 'XD') {
        addToCartBtnClass = `btn btn-red general-add-to-cart-btn btn-full xdining-atc-modal-open-button ${addToCartUniqueClass}`;
        addToCartBtnAttributes = `data-productcode="${productTileData.code}"
                                data-csrf="${CSRFToken}"
                                data-usermode="loggedInBuy"
                                data-sailingInfoNeeded="${productTileData.sailingInfoNeeded}"`;
      } else {
        if ((productTileData.itemType !== 'TransfersProduct' && productTileData.itemType !== 'TransfersProductModel')) {
          addToCartBtnClass = `btn btn-red general-add-to-cart-btn fs-btn-add-cart btn-full ${addToCartUniqueClass}`;
          addToCartBtnAttributes = `data-csrf="${CSRFToken}"
                                  data-funshopcategorycode="${response.categoryCode}"
                                  data-hasvariants="${hasProductVariant}"
                                  data-productcode="${prodCode}"`;
        }
      }
    }

    return { addToCartBtnClass, addToCartBtnAttributes };
  },

  getCarouselHtml(productTileData, response) {
    const width = 400;
    const height = 225;
    let src = '';

    if (productTileData.images[0] !== null) {
      src = `${productTileData.images[0].url}&w=${width}&h=${height}`;
    } else {
      src = `/shop/medias/missing-store-300x300.jpg?context=bWFzdGVyfGltYWdlc3wxNTk2NTN8aW1hZ2UvanBlZ3xoZDYvaDZhLzg3OTgxMjQ3MzY1NDIvbWlzc2luZy1zdG9yZS0zMDB4MzAwLmpwZ3wyOTcyMGExMGYyNzRlZDM5OTkyNDdhNGFhMjAyMGVlNDhmODYwOGU1MmQxY2U4MTNjYzVkN2I1YzJhY2Q5MWFl&w=${width}&h=${height}`;
    }

    return src;
  },

  eyeBrowHtml(productTileData) {
    const start = '<span class="ccl_product_type general-ccl-product-type">';
    let html = '';
    const end = '</span>';

    if ((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel')) {
      // display port name along with category
      html += `<span class="ccl_productSuperCategory general-product-supercategory">
        ${productTileData.rootCategoryName}
      </span>
      <span class="ccl_productCategory general-product-category">
        <span class="general-hyphen">-</span>
        ${productTileData.shoreExData.portData.name}
      </span>`;
    }

    if ((productTileData.itemType !== 'ShoreExProduct' && productTileData.itemType !== 'ShoreExProductModel')) {
      if (productTileData.categoryHierarchy !== null) {
        html += `<span class="ccl_productSuperCategory general-product-supercategory">${productTileData.superCategory}</span>`;
        if (productTileData.category !== null) {
          html += `<span class="ccl_productCategory general-product-category">
          <span class="general-hyphen">-</span> ${productTileData.category}</span>`;
        }
        if (productTileData.subCategory !== null) {
          html += `<span class="ccl_productSubCategory general-product-subcategory">
          <span class="general-hyphen">-</span> ${productTileData.subCategory}</span>`;
        }
      } else {
        html += `<span class="ccl_productSuperCategory general-product-supercategory">${productTileData.rootCategoryName}</span>`;
      }
    }

    return `${start} ${html} ${end}`;
  },
  /* eslint-enable */

  isWheelChair(productTileData) {
    if (((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel')) && ((productTileData.shoreExData.wheelchairAccessable != null && productTileData.shoreExData.wheelchairAccessable === true))) {
      return true;
    }
    return false;
  },

  tilesClickEvents() {
    $('.owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      touchDrag: true,
      mouseDrag: true,
      margin: 0,
      items: 1
    });

    // Lazy load images
    if ($('img.lazy').length) {
      if ($('#lazyLoadingEnabled').data('enabled') === 'true' || $('#lazyLoadingEnabled').data('enabled') === true) {
        CCL.lazyLoadInstance.update();
      }
    }
    window.googleAnalytics();
  },

  getPaginationFooterHtml(response) {
    if (response && response.productCategorySearchPageData && response.productCategorySearchPageData.pagination) {
      const { totalNumberOfResults, currentPage, pageSize } = response.productCategorySearchPageData.pagination;
      const newPageSize = totalNumberOfResults < pageSize ? totalNumberOfResults : pageSize;
      const start = (newPageSize * (currentPage + 1)) - (newPageSize - 1);
      let end = newPageSize * (currentPage + 1);
      end = totalNumberOfResults < end ? totalNumberOfResults : end;
      if (totalNumberOfResults === 0 || totalNumberOfResults === null) {
        return '';
      } else if (totalNumberOfResults === 1) {
        return `<b>1</b> Out of <b>${totalNumberOfResults} Results</b>`;
      }
      return `<b>${start}-${end}</b> Out of <b>${totalNumberOfResults} Results</b>`;
    }

    return '';
  },

  sortRegionByAlpha(a, b) {
    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
    if (b.name.toLowerCase() > a.name.toLowerCase()) return -1;

    return 0;
  },

  sortPortByAlpha(x, y) {
    if (x.portRegionName && y.portRegionName) {
      if (x.portRegionName.toLowerCase() > y.portRegionName.toLowerCase()) return 1;
      if (y.portRegionName.toLowerCase() > x.portRegionName.toLowerCase()) return -1;
    }

    return 0;
  },

  groupPortByRegion(response) {
    const arr = [];
    let uniqueArr = [];
    response.groupPortByRegion = false;
    if (response && response.productCategorySearchPageData && response.productCategorySearchPageData.facets) {
      $.each(response.productCategorySearchPageData.facets, (key, val) => {
        if (val.code === 'port' && (response.userFlowType === 'BROWSE' || response.userFlowType === 'LOGGED_IN_BROWSE')) {
          response.groupPortByRegion = true;
          $.each(val.values, (innerKey, innerVal) => {
            const tempAr = val.values.filter(x => x.portRegionName === innerVal.portRegionName);
            arr.push({ portRegionName: innerVal.portRegionName, data: tempAr.sort(this.sortRegionByAlpha) });
          });
        }
      });
      uniqueArr = Array.from(new Set(arr.map(JSON.stringify))).map(JSON.parse);
      return uniqueArr.length ? uniqueArr.sort(this.sortPortByAlpha) : false;
    }
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-ajax-clp/c-ajax-clp.js